export const AppActions = {
  discoverMoreWidgets: 'discoverWidgets',
  managePages: 'managePages',
  openDashboard: 'openAppDashboard',
};
